export default __webpack_public_path__ + "static/media/megaphone.18e27247.svg";